import { FunctionComponent } from 'react';
import { RelatedModel } from '../../../services/content/related/models/RelatedModel';
import { getTagsFromRelated } from '../../../services/content/related/RelatedHelper';
import { TagModel } from '../../../services/content/tag/models/TagModel';
import { Tag } from './Tag';
import styles from './../../../styles/Tags.module.scss';

type Props = {
    related: RelatedModel[];
};

export const Tags: FunctionComponent<Props> = ({ related }) => {
    const tags = getTagsFromRelated(related);

    return (
        <div className={`${styles.tagsContainer} mb-3`}>
            {tags.map((tag) => {
                return <Tag key={`tag-key-${tag.data?.id}`} tag={tag.data as TagModel} className='me-3' />;
            })}
        </div>
    );
};
